import avatar1 from './10638133.jpg';
import avatar2 from './11003843.jpg';
import avatar3 from './7002360.jpg';
import avatar4 from './7002362.jpg';
import avatar5 from './8899031.jpg';

export const AVATAR_POOL = [avatar1, avatar2, avatar3, avatar4, avatar5];

export const getFallbackAvatar = (key) => {
    if (!AVATAR_POOL.length) {
        return undefined;
    }

    if (!key) {
        return AVATAR_POOL[Math.floor(Math.random() * AVATAR_POOL.length)];
    }

    let hash = 0;
    const value = String(key);
    // Simple deterministic hash: djb2 variant
    for (let index = 0; index < value.length; index += 1) {
        hash = (hash * 33) ^ value.charCodeAt(index);
    }

    const normalized = Math.abs(hash) % AVATAR_POOL.length;
    return AVATAR_POOL[normalized];
};
